<script>
import StoreCardMixin from '@phoenix/mixins/components/store/storeCardMixin';
import { PhxIcon } from '@phx-styleguides/pia';
import PictureLazy from '@maison/components/common/PictureLazy.vue';

export default {
  components: {
    PhxIcon,
    PictureLazy,
  },

  mixins: [StoreCardMixin],

  props: {
    backgroundColor: {
      type: String,
      default: null,
    },
  },
};
</script>

<template>
  <div class="boutique-card" :style="{ '--background-color': backgroundColor }">
    <div class="boutique-card__inner">
      <div class="picture picture--responsive" style="background-color: #c8c3be">
        <picture-lazy v-if="image" :sources="image.sources" :image="image.image" :alt="image.alt" :lazy="image.lazy" />
      </div>

      <template v-if="permalink">
        <a :href="permalink" class="expand-target">
          <h2 class="h5 boutique-card__title">{{ title }}</h2>
        </a>
      </template>
      <template v-else>
        <h2 class="h5 boutique-card__title">{{ title }}</h2>
      </template>

      <div class="boutique-card__description" v-html="address"></div>

      <div v-if="status" class="boutique-card__opening-info">{{ status }}</div>
    </div>

    <ul class="boutique-card__actions">
      <li v-if="phone" class="boutique-card__action">
        <a
          :href="`tel:${phone.replace(/\s/g, '')}`"
          class="btn btn--secondary btn--full btn--xs"
          :aria-label="$t('Styleguide.store-locator.call-boutique')"
          :title="$t('Styleguide.store-locator.call-boutique')"
          v-bind="additionalProps"
        >
          <span class="btn__icon btn__icon--start">
            <phx-icon icon="phone" class="icon--xs" />
          </span>
          <span dir="ltr">{{ phoneLabel || phone }}</span>
        </a>
      </li>

      <li v-if="permalink" class="boutique-card__action">
        <a :href="permalink" class="btn btn--secondary btn--full btn--xs">
          <span class="btn__icon btn__icon--start">
            <phx-icon icon="plus" class="icon--xs" />
          </span>
          {{ seeMoreLabel }}
        </a>
      </li>
    </ul>

    <template v-if="productCategories">
      <div class="boutique-card__services-title">{{ $t('store.productCategoriesTitle') }}</div>

      <ul class="boutique-card__services-list">
        <li v-for="(productCategory, i) in productCategories" :key="i" class="boutique-card__services-list-item">
          <div class="boutique-card__service">
            <phx-icon :icon="productCategory.icon" />
            <span>{{ productCategory.title }}</span>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>
